import { Component, computed, input } from "@angular/core";
import { FormPlaceholderLayout, IFormPlaceholderAdvanced } from "./form-placeholder.models";

@Component({
	selector: "rl-form-placeholder",
	templateUrl: "./form-placeholder.component.html",
	styleUrls: ["./form-placeholder.component.scss"],
	imports: []
})
export class FormPlaceholderComponent {

	numRows = input<number>(null);
	placeholderLayout = input<FormPlaceholderLayout>(FormPlaceholderLayout.Basic);
	advanced = input<IFormPlaceholderAdvanced>(null);

	formPlaceholderLayout = FormPlaceholderLayout;

	rows = computed(() => Array.from({ length: this.numRows() ?? 0 }, (_, i) => i));

	constructor() { }

}